<template>
	<div style="padding: 10px;">
		<div style="width: 48%;float: left;margin-top: 10px;margin-right: 10px;">
			<el-row :gutter="20">
				<el-col :span="12">
					<el-input clearable placeholder="按类型名称查询" v-model="searchInfo.name">
						<template slot="prepend">类型名称</template>
					</el-input>
				</el-col>
				<el-col :span="12"> 
					<div style="min-width: 300px;">
						<el-button type="primary" @click="searchDevType" icon="el-icon-search">搜索</el-button>
						<el-button  icon="el-icon-refresh" @click="clearSearch">重置</el-button>
						<el-button type="primary" icon="el-icon-plus" @click="addDevType">新增</el-button>
					</div>
				</el-col>
			</el-row>
			<div style="margin-top: 10px;">
				<el-table :data="sysDevTypeList"  style="width: 100%"  max-height="700">
				    <el-table-column fixed="left" prop="name" label="类型名称" align="center"></el-table-column>
					<el-table-column prop="code" label="类型编码" align="center"></el-table-column>
				    <el-table-column prop="idx" label="排序"  width="150" align="center"></el-table-column>
					<el-table-column fixed="right" prop="op" label="操作" width="150" align="center">
						<template slot-scope="scope">
							<a @click="goDevTypeDetail(scope.$index, scope.row)" title="详情" style="display:inline-block;cursor:pointer;color: #409EFF;">
								<i class="el-icon-Stall">详情</i>
							</a>
							<!-- <a @click="noUseDetail(scope.$index, scope.row)" title="删除" style="display:inline-block;cursor:pointer;color: #F56C6C;margin-left: 20px;">
								<i class="el-icon-Stall">删除</i>
							</a> -->
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div style="text-align: center;">
				<el-pagination background layout="total, prev, pager, next, sizes" :page-sizes="[10, 20, 50]" :current-page="param.page"
					:page-size="param.pagenum" :total="userTotal" @size-change="handleSizeChange" @current-change="handleCurrentChange"> </el-pagination>
			</div>
		</div>
		<div style="width: 48%;float: left;margin-top: 10px;margin-left: 10px;">
			<el-row :gutter="20">
				<el-col :span="12">
					<el-input clearable placeholder="按类型名称查询" v-model="searchModelInfo.name">
						<template slot="prepend">类型名称</template>
					</el-input>
				</el-col>
				<el-col :span="12"> 
					<div style="min-width: 300px;">
						<el-button type="primary" @click="searchDevModel" icon="el-icon-search">搜索</el-button>
						<el-button  icon="el-icon-refresh" @click="clearSearchModel">重置</el-button>
						<el-button type="primary" icon="el-icon-plus" @click="addDevModel">新增</el-button>
					</div>
				</el-col>
			</el-row>
			<div style="margin-top: 10px;">
				<el-table :data="sysDevModelList"  style="width: 100%"  max-height="700">
				    <el-table-column fixed="left" prop="name" label="型号名称" align="center"></el-table-column>
					<el-table-column prop="code" label="型号编码" align="center"></el-table-column>
				    <el-table-column prop="idx" label="排序"  width="150" align="center"></el-table-column>
					<el-table-column fixed="right" prop="op" label="操作" width="150" align="center">
						<template slot-scope="scope">
							<a @click="goDevModelDetail(scope.$index, scope.row)" title="详情" style="display:inline-block;cursor:pointer;color: #409EFF;">
								<i class="el-icon-Stall">详情</i>
							</a>
							<!-- <a @click="noUseModelDetail(scope.$index, scope.row)" title="删除" style="display:inline-block;cursor:pointer;color: #F56C6C;margin-left: 20px;">
								<i class="el-icon-Stall">删除</i>
							</a> -->
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div style="text-align: center;">
				<el-pagination background layout="total, prev, pager, next, sizes" :page-sizes="[10, 20, 50]" :current-page="paramModel.page"
					:page-size="paramModel.pagenum" :total="modelTotal" @size-change="handleModelSizeChange" @current-change="handleModelCurrentChange"> </el-pagination>
			</div>
		</div>
		<el-dialog @close="refrashData" :destroy-on-close="true" :title="detailTitle" width="70%" :visible.sync="detailShow">
			<el-form :inline="false" :model="selectset" :rules="typerules" ref="devtyperule" label-width="120px" class="">
				<el-row>
					<el-col :span="8">
						<el-form-item label="类型名称" prop="name">
							<el-input clearable :disabled="!editok" v-model="selectset.name" maxlength="30"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="类型编码" prop="code">
							<el-input clearable :disabled="!editok" v-model="selectset.code" maxlength="30"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="排序" prop="idx">
							<el-input-number :disabled="!editok" v-model="selectset.idx" :min="1" :max="999" :precision="2" :step="0.1" ></el-input-number>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<div style="text-align: center;" v-if="isadd">
				<el-button v-show="editok" type="primary" @click="saveAddType">保存</el-button>
			</div>
			<div style="text-align: center;" v-else>
				<el-button v-show="!editok" type="primary" @click="editok = true">修改</el-button>
				<el-button v-show="editok" plain @click="editok = false">取消</el-button>
				<el-button v-show="editok" type="primary" @click="saveDevType">保存</el-button>
			</div>
		</el-dialog>
		<el-dialog @close="refrashModelData" :destroy-on-close="true" :title="detailModelTitle" width="70%" :visible.sync="detailModelShow">
			<el-form :inline="false" :model="selectModelset" :rules="modelrules" ref="devmodelrule" label-width="120px" class="">
				<el-row>
					<el-col :span="8">
						<el-form-item label="型号名称" prop="name">
							<el-input clearable :disabled="!editModelok" v-model="selectModelset.name" maxlength="30"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="型号编码" prop="code">
							<el-input clearable :disabled="!editModelok" v-model="selectModelset.code" maxlength="30"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="排序" prop="idx">
							<el-input-number :disabled="!editModelok" v-model="selectModelset.idx" :min="1" :max="999" :precision="2" :step="0.1" ></el-input-number>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<div style="text-align: center;" v-if="isModeladd">
				<el-button v-show="editModelok" type="primary" @click="saveAddModel">保存</el-button>
			</div>
			<div style="text-align: center;" v-else>
				<el-button v-show="!editModelok" type="primary" @click="editModelok = true">修改</el-button>
				<el-button v-show="editModelok" plain @click="editModelok = false">取消</el-button>
				<el-button v-show="editModelok" type="primary" @click="saveDevModel">保存</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	//import dayjs from 'dayjs'
	import { queryRealDevTypeByPage, addRealDevType, editRealDevType,
		editRealDevModel, addRealDevModel, queryRealDevModelByPage } from '/static/apiUrl.js'
	export default {
		name : 'DevType',
		data() {
			return {
				detailShow: false,
				editok : false,
				isadd : false,
				detailTitle: '类型详情',
				selectset: {
					id: '',
					name : '',
					code : '',
					idx : 1,
				},	
				searchInfo:{
					name: '',
					orgs : '',
				},
				param : {
					page : 1,
					pagenum : 10,
				},
				userTotal : 0,
				sysDevTypeList : [],
				detailModelShow: false,
				editModelok : false,
				isModeladd : false,
				detailModelTitle: '类型详情',
				selectModelset: {
					id: '',
					name : '',
					code : '',
					idx : 1,
				},	
				searchModelInfo:{
					name: '',
					orgs : '',
				},
				paramModel : {
					page : 1,
					pagenum : 10,
				},
				modelTotal : 0,
				sysDevModelList : [],
				typerules:{
					name: [
						{ required: true, message: '请输入类型名称', trigger: 'blur' }
					],
					code: [
						{ required: true, message: '请输入类型编码', trigger: 'blur' }
					],
				},
				modelrules:{
					name: [
						{ required: true, message: '请输入类型名称', trigger: 'blur' }
					],
					code: [
						{ required: true, message: '请输入类型编码', trigger: 'blur' }
					],
				},
			}
		},
		mounted() {
			this.initData()
		},
		components: {
		},
		methods: {
			handleSizeChange(val){
				this.param.pagenum = val;
				this.queryDevTypeList()
			},
			handleCurrentChange(val){
				this.param.page = val
				this.queryDevTypeList()
			},
			handleModelSizeChange(val){
				this.paramModel.pagenum = val;
				this.queryDevModelList()
			},
			handleModelCurrentChange(val){
				this.paramModel.page = val
				this.queryDevModelList()
			},
			initData() {
				this.queryDevTypeList()
				this.queryDevModelList()
			},
			searchDevType(){
				this.param.page = 1
				this.sysDevTypeList = []
				this.queryDevTypeList()
			},
			clearSearch(){
				this.searchInfo.name = ''
				this.searchInfo.orgs = ''
				this.param.page = 1
				this.queryDevTypeList()
			},
			searchDevModel(){
				this.paramModel.page = 1
				this.sysDevModelList = []
				this.queryDevModelList()
			},
			clearSearchModel(){
				this.searchModelInfo.name = ''
				this.searchModelInfo.orgs = ''
				this.paramModel.page = 1
				this.queryDevModelList()
			},
			queryDevTypeList(){
				this.sysDevTypeList = []
				queryRealDevTypeByPage({
					name : this.searchInfo.name,
					pagenum : this.param.page ,
					pagesize : this.param.pagenum
				}).then(res => {
					//console.log(res)
					if(0 == res.code){
						this.userTotal = res.datas.totalnum
						res.datas.data.forEach((set) => {
							this.sysDevTypeList.push(set)
						})
					}
				})
			},
			queryDevModelList(){
				this.sysDevModelList = []
				queryRealDevModelByPage({
					name : this.searchInfo.name,
					pagenum : this.param.page ,
					pagesize : this.param.pagenum
				}).then(res => {
					//console.log(res)
					if(0 == res.code){
						this.modelTotal = res.datas.totalnum
						res.datas.data.forEach((set) => {
							this.sysDevModelList.push(set)
						})
					}
				})
			},
			goDevTypeDetail(idx,row){
				this.detailTitle = '设备类型详情'
				this.isadd = false
				this.selectset = JSON.parse(JSON.stringify(this.sysDevTypeList[idx]))
				this.detailShow = true
				this.editok = false
			},
			goDevModelDetail(idx,row){
				this.detailModelTitle = '设备型号详情'
				this.isModeladd = false
				this.selectModelset = JSON.parse(JSON.stringify(this.sysDevModelList[idx]))
				this.detailModelShow = true
				this.editModelok = false
			},
			noUseDetail(idx,row){
				/* this.$confirm('此操作将删除 '+this.sysDevTypeList[idx].name+', 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					
				}).catch(() => {
					console.log("取消")
				}); */
			},
			addDevType(){
				this.detailTitle = "新增设备类型"
				this.isadd = true
				this.editok = true
				this.selectset = {
					id: '',
					name : '',
					code : '',
					idx : 1,
				}
				this.detailShow = true
			},
			addDevModel(){
				this.detailModelTitle = "新增设备型号"
				this.isModeladd = true
				this.editModelok = true
				this.selectModelset = {
					id: '',
					name : '',
					code : '',
					idx : 1,
				}
				this.detailModelShow = true
			},
			refrashData() {
				if(this.editok){
					this.queryDevTypeList()
				}
			},
			refrashModelData() {
				if(this.editModelok){
					this.queryDevModelList()
				}
			},
			saveDevType(){
				this.$refs["devtyperule"].validate((valid) => {
					if (valid) {
						editRealDevType(this.selectset).then(res => {
							if(0 == res.code){
								this.$message({
									showClose: true,
									message: "修改成功",
									type: 'success'
								});
							}else{
								this.$message({
									showClose: true,
									message: res.message,
									type: 'error'
								});
							}
							this.detailShow = false
						})
					} else {
						return false;
					}
				})
			},
			saveAddType(){
				this.$refs["devtyperule"].validate((valid) => {
					if (valid) {
						addRealDevType(this.selectset).then(res => {
							if(0 == res.code){
								this.$message({
									showClose: true,
									message: "添加成功",
									type: 'success'
								});
							}else{
								this.$message({
									showClose: true,
									message: res.message,
									type: 'error'
								});
							}
							this.detailShow = false
						})
					} else {
						return false;
					}
				})
			},
			saveDevModel(){
				this.$refs["devmodelrule"].validate((valid) => {
					if (valid) {
						editRealDevModel(this.selectModelset).then(res => {
							if(0 == res.code){
								this.$message({
									showClose: true,
									message: "保存成功",
									type: 'success'
								});
							}else{
								this.$message({
									showClose: true,
									message: res.message,
									type: 'error'
								});
							}
							this.detailModelShow = false
						})
					} else {
						return false;
					}
				})
			},
			saveAddModel(){
				this.$refs["devmodelrule"].validate((valid) => {
					if (valid) {
						addRealDevModel(this.selectModelset).then(res => {
							if(0 == res.code){
								this.$message({
									showClose: true,
									message: "添加成功",
									type: 'success'
								});
							}else{
								this.$message({
									showClose: true,
									message: res.message,
									type: 'error'
								});
							}
							this.detailModelShow = false
						})
					} else {
						return false;
					}
				})
			},
		},
		beforeDestroy() {
			
		},
	}
</script>

<style scoped>
	
</style>